<template lang="html">
	<select class="form-control custom-select d-sm-none" @change="redirect" v-model="selected">
		<slot></slot>
	</select>
</template>

<script>

export default {

	data() {
		return {
			selected: '',
		}
	},

	mounted() {

	},

	methods: {

		redirect: function() {
			window.location.href = this.selected
		},

	}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AccountNavSelect.vue